export default {
  INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_REPOSITORY: Symbol.for('INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_REPOSITORY'),
  GET_INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_QUERY: Symbol.for('GET_INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_QUERY'),
  INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_STATE_MANAGER: Symbol.for('INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_STATE_MANAGER'),
};
